import {DatasetDataInfoResponse, InstantDoubleValue} from "../api/apiModels";

export const formatDatasetValue = (dataset:DatasetDataInfoResponse, data: InstantDoubleValue | null | undefined) =>
    data ? data.value.toFixed(dataset?.decimalPlaces ?? 2) : "N/A";